import { logWrapper } from '../utils';

export default function truncateName(runtimeConstant) {
  function run() {
    try {
      return function (input, size) {
        if (input === null || input === undefined || typeof input !== 'string')
          return '';

        var names = input.split(' ');
        var value = '' + names[0][0].toUpperCase() + names[0].slice(1);

        if (size === undefined || size === null || size <= 0) size = 1;

        for (var i = 1, len = names.length; i < len && i <= size; i++) {
          var name = names[names.length - i];
          if (name[0]) {
            value += ' ' + name[0].toUpperCase() + name.slice(1);
          }
        }

        return value;
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  // Wrap the setup function with logWrapper for debugging purposes
  return logWrapper(run, runtimeConstant.isDebugFilters)();
}
